/**
 * A logger. Should be used as a singleton
 */
class Logger {

    /**
     *
     * @param debug {boolean} If false, this logger will not log debug messages
     */
    constructor(debug) {
        this.setDebug(debug);
    }

    /**
     * Is this logger on debug?
     * @returns {boolean}
     */
    isOnDebug(){
        return this.onDebug;
    }

    /**
     * Log a debug message
     * @param msg {string} The message to log
     * @param obj {*} An object to log. Will not be converted to string, so the browser will pretty print it
     */
    logDebug(msg, obj=undefined) {
        if (this.onDebug) {
            this._log("DEBUG", msg, obj);
        }
    }

    /**
     * Log an info message
     * @param msg {string} The message to log
     * @param obj {*} An object to log. Will not be converted to string, so the browser will pretty print it
     */
    logInfo(msg, obj=undefined) {
        this._log("INFO", msg, obj);
    }

    /**
     * Log an error message
     * @param msg {string} The message to log
     * @param obj {*} An object to log. Will not be converted to string, so the browser will pretty print it
     */
    logError(msg, obj=undefined) {
        if (this.onDebug) {
            this._log("ERROR", msg, obj);
        } else {
            this._log("ERROR", msg);
        }
    }

    _log(level, msg, obj=undefined) {
        const d = new Date();
        const dateString = d.getFullYear() + "-" + (d.getMonth() + 1).pad(2) + "-" + d.getDate().pad(2) + " " +
            d.getHours().pad(2) + ":" + d.getMinutes().pad(2) + ":" + d.getSeconds().pad(2)+'.'+d.getMilliseconds();
        const logStr = '[' + dateString + ']\t[' + level + ']\t';
        if (obj) {
            console.log(logStr + '------------------------------------');
        }
        if (msg) {
            console.log(logStr + msg);
        }
        if (obj) {
            console.log(obj);
            console.log(logStr + '------------------------------------');
        }
    }

    /**
     *
     * @param debug {boolean} If false, this logger will not log debug messages
     */
    setDebug(debug){
        if((!!this.onDebug)!==(!!debug)) {
            if (debug) {
                this.logInfo("Debug logging enabled");
            }else {
                this.logInfo("Debug logging disabled");
            }
            this.onDebug = !!debug;
        }
    }
}

export {Logger}